import { Image } from 'antd';
import type {
  ProColumns,
  ProFormColumnsType,
  ProRenderFieldPropsType,
} from '@ant-design/pro-components';
import MyUpload from '@/components/my-upload';
import { getFileName } from '@/components/my-upload/scripts/utils';

export type CustomValueTypes = 'upload';

export const valueTypeMap: Record<CustomValueTypes, ProRenderFieldPropsType> = {
  upload: {
    render(text) {
      if (text && /\.(jpe?g|png|gif|webp|ico)/i.test(text)) {
        return <Image src={text} width={50} height={50}></Image>;
      }
      return (
        <a href={text} target="_blank" rel="noreferrer">
          {getFileName(text)}
        </a>
      );
    },
    renderFormItem(_, props) {
      return <MyUpload {...props?.fieldProps} />;
    },
  },
};

export type MyProColumns<T = MyRecord, ValueType = 'text'> = ProColumns<
  T,
  CustomValueTypes | ValueType
>;

export type MyProFormColumns<T = MyRecord, ValueType = 'text'> = ProFormColumnsType<
  T,
  CustomValueTypes | ValueType
>;
